/*
  MENU ITEMS
  path - url path in browser to match active class to highlight item
  route name is the vue router route name
  admin true - only user with is_admin=1 will show menu
*/
export default [
    {
        title: "Home",
        routeName: "home",
        icon: "lni lni-home",
        paths: ["/home"],
        active: false,
    },


    {
        title: "Schemes",
        routeName: "schemes",
        icon: "lni  lni-bricks",
        paths: ["/schemes"],
        active: false,
        permissions: ["Manage schemes"],
        childVisible: false,        
    },

    {
        title: "Contributions",
        icon: "lni  lni-money-location",
        paths: ["/contributions"],
        active: false,
        permissions: ["Manage contributions"],
        childVisible: false,    
        children: [
           

            {
                title: "Outstanding",
                routeName: "contributions-outstanding",
                permissions: ["Manage contributions"],
            },
            {
                title: "Processed",
                routeName: "contributions-processed",
                permissions: ["Manage contributions"],
            },
            {
                title: "Create Ad hoc",
                routeName: "contributions-ad-hoc",
                permissions: ["Manage contributions"],
            },
            {
                title: "Scheme Debits",
                routeName: "contributions-debits",
                permissions: ["Manage debits"],
            },
        ]    
    },

    {
        title: "Contributors",
        routeName: "contributors",
        icon: "lni  lni-customer",
        paths: ["/contributors"],
        active: false,
        permissions: ["Manage contributors"],
        childVisible: false,        
    },


    {
        title: "Reports",
        routeName: "reports",
        icon: "lni  lni-library",
        paths: ["/reports"],
        active: false,
        permissions: ["View reports"],
        childVisible: false,        
    },


    
    {
        title: "System",
        icon: "lni lni-cogs",
        paths: ["/settings", "/organisations", "parameters"],
        active: false,
        permissions: ["Manage organisations"],
        childVisible: false,
        children: [
           

            // {
            //     title: "Parameters",
            //     routeName: "parameters",
            //     permissions: ["Manage organisations"],
            // },
            {
                title: "Organisation",
                routeName: "organisations",
                permissions: ["Manage organisations"],
            },
        ],
    },

    {
        title: "Users & Roles",
        icon: "lni lni-users",
        paths: ["/users", "/roles", "/user-logs"],
        active: false,
        permissions: ["Manage users", "Manage roles"],
        childVisible: false,
        children: [
            {
                title: "User Management",
                routeName: "users",
                permissions: ["Manage users"],
            },
            {
                title: "Roles Management",
                routeName: "roles",
                permissions: ["Manage roles"],
            },      
        ],
    },

    {
        title: "Admin",
        icon: "lni lni-warning",
        paths: ["/admin"],
        active: false,
        admin: true,
        childVisible: false,
        children: [
            {
                title: "Horizon Interface",
                routeName: "horizon",
            },
            {
                title: "Telescope Interface",
                routeName: "telescope",
            },
            {
                title: "User Logs",
                routeName: "user-logs",
            },
        ],
    },


];
